// src/utils/date.ts
import dayjs, { type Dayjs } from 'dayjs';

import { ENV } from '@/lib/env';

export const DEFAULT_YEAR = process.env.NODE_ENV === ENV.PRODUCTION ? 2024 : 2021;

export const NULL_DATES = [null, null] as unknown as [Dayjs, Dayjs];

// Using JS Date to avoid month indexing confusion.
export const getDefaultDateRange = (): [Dayjs, Dayjs] => {
  const start = dayjs(new Date(DEFAULT_YEAR, 0, 1)); // Jan 1
  const end = dayjs(new Date(DEFAULT_YEAR, 11, 1)); // Dec 1
  return [start, end];
};
